import * as React from 'react'

export default function GenericComponent({ Component, hidden }) {
  return hidden ? <></> : <Component />
}
